const Footer = () => {
  return <section className="footer">
    <span>Yagnaguru Ravichandran</span>
  </section>;
};

export default Footer;
